import { desistenteFlag } from "./generalBoardHighlights";

const HIGHLIGHT_COLORS = new Set([
  "#C6EFCE",
  "#FFEB9C",
  "#FCE4D6",
  "#FFC7CE",
  "#DDEBF7",
  "#D9D9D9"
]);

const BASE_KINDS = new Set(["desistente"]);
const APPLY_KINDS = new Set([
  "name",
  "ra",
  "totalAbsencesPeriod",
  "absencesPercentPeriod",
  "attendance"
]);
const OPERATORS = new Set([
  "empty",
  "notEmpty",
  "eq",
  "neq",
  "gt",
  "gte",
  "lt",
  "lte",
  "between",
  "contains"
]);

function isPlainObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

function createHighlightId() {
  return `hl_${Date.now().toString(36)}_${Math.random()
    .toString(36)
    .slice(2, 8)}`;
}

function applyKindFromBase(baseKind) {
  if (baseKind === "desistente") return "name";
  if (APPLY_KINDS.has(baseKind)) return baseKind;
  return "name";
}

function normalizeApplyTo(raw, baseKind) {
  const fallback = [applyKindFromBase(baseKind)];
  if (!isPlainObject(raw) || raw.mode !== "columns") {
    return { mode: "row", columns: [] };
  }
  const columns = Array.isArray(raw.columns)
    ? raw.columns.filter(key => APPLY_KINDS.has(key))
    : [];
  if (!columns.length) {
    return { mode: "columns", columns: fallback };
  }
  return { mode: "columns", columns };
}

function normalizeHighlight(raw, index = 0) {
  if (!isPlainObject(raw)) return null;
  const kind = String((raw.base && raw.base.kind) || "");
  if (!BASE_KINDS.has(kind)) return null;
  const isDesistente = kind === "desistente";
  const operator = isDesistente ? "eq" : String(raw.operator || "");
  if (!OPERATORS.has(operator)) return null;
  const color = String(raw.color || "");
  if (!HIGHLIGHT_COLORS.has(color)) return null;

  let value = "";
  if (isDesistente) {
    value = "S";
  } else if (raw.value != null) {
    value = String(raw.value);
  }

  return {
    id: raw.id ? String(raw.id) : createHighlightId(),
    order: Number.isFinite(Number(raw.order)) ? Number(raw.order) : index,
    base: { kind },
    operator,
    value,
    valueTo: "",
    color,
    applyTo: normalizeApplyTo(raw.applyTo, kind)
  };
}

export function normalizeFrequencyHighlights(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((item, index) => normalizeHighlight(item, index))
    .filter(Boolean)
    .sort((a, b) => a.order - b.order)
    .map((item, index) => ({ ...item, order: index }));
}

function ruleMatchesStudent(rule, student) {
  if (!rule || !rule.base) return false;
  if (rule.base.kind === "desistente") {
    return desistenteFlag(student && student.desistente) === "S";
  }
  return false;
}

function isTarget(rule, cellKind) {
  // mode row: toda a linha (igual ao quadro geral)
  if (!rule.applyTo || rule.applyTo.mode !== "columns") {
    return true;
  }
  return (rule.applyTo.columns || []).includes(cellKind);
}

/**
 * Cor do destaque configurado via settings da grade (não cobre o laranja de
 * "faltou em aula anterior").
 */
export function resolveFrequencyHighlightColor(highlights, cellKind, student) {
  if (!Array.isArray(highlights) || !highlights.length) return null;
  let color = null;
  [...highlights]
    .sort((a, b) => a.order - b.order)
    .forEach(rule => {
      if (!ruleMatchesStudent(rule, student)) return;
      if (isTarget(rule, cellKind)) {
        color = rule.color;
      }
    });
  return color;
}
